/* eslint-disable */
const eventsOnlyOnceList = [];

/**
 * The action type event
 * @param {func} metaDataFunc The meta data func
 * @returns {any} The analytics data
 */
const actionTypeEvent = (metaDataFunc) => ({ payload, onlyOnce, type }) => {
  const hasEventAlreadyHappened = eventsOnlyOnceList.find((event) => event === type);
  if (onlyOnce) {
    if (hasEventAlreadyHappened) {
      return null;
    }
    eventsOnlyOnceList.push(type);
  }
  // ref: https://rangle.gitbook.io/redux-beacon/index/google-tag-manager#event-definitions
  // payload here acts as extra key/value pair here, key is payload, value is anything
  return {
    ...(metaDataFunc && metaDataFunc()),
    event: type,
    payload,
  };
};

/**
 * Applies a common event function to different event types
 * @param {Array<string>} events The events array
 * @param {func} eventFunc The event function to apply
 * @returns {any} The analytics data
 */
const applyEvent = (events, eventFunc) => {
  return events.reduce((eventsMap, currentEvent) => {
    return {
      ...eventsMap,
      [currentEvent]: eventFunc,
    };
  }, {});
};

/**
 * The events using the action types
 * @param {Array} types The action types
 * @returns {any} The analytics data
 */
export const createActionTypeEvents = (types) => (metaDataFunc) => applyEvent(
  Object.values(types),
  actionTypeEvent(metaDataFunc),
)

/**
 * createEventsMap
 * @param {any} eventList The eventList
 * @param {func} metaDataFunc The metaDataFunc
 * @returns {any} The middleware
 */
export const createEventsMap = (eventList, metaDataFunc) => {
  const reduced = eventList.reduce((prev, eventFunc) => {
    return {
      ...prev,
      ...eventFunc(metaDataFunc),
    };
  }, {});
  return reduced
};
